import styled from '@emotion/styled'
import Form from 'antd/lib/form'
import { Col, Tabs, Modal } from 'antd'

export const LoyaltyProductLabel = styled(Form.Item)`
  & > * > label {
    width: 100%;
  }
  & > * > label > .ant-row {
    margin-bottom: 0;
  }
`

export const EmailListCol = styled(Col)`
  padding: 8px 16px;
  border-radius: 4px;
  background-color: #f3f2f4;
  font-size: 14px;
  line-height: 1.5;
  color: #4a4a68;
`

export const BulkRewardsTabs = styled(Tabs)`
  .ant-tabs-content-holder {
    max-height: 400px;
    overflow-y: scroll;
    margin-top: 16px;
  }
`

export const LoyaltyQrModal = styled(Modal)`
  > * > .ant-modal-footer {
    display: flex;
    justify-content: space-between;
  }

  > * > .ant-modal-header {
    background: #4a4a68;
  }

  .qr-modal-header {
    display: flex;
    justify-content: space-between;

    > .title {
      margin: 0;
      color: white;
      font-size: 18px;
      font-weight: 500;
    }

    > .context {
      display: flex;
      align-items: center;
      font-size: 14px;
      color: #fff;
    }

    > .context > .name {
      color: #d092dd;
      font-size: 12px;
      margin: 0;
      margin-left: 8px;
    }
  }
`
